import { Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ToasterComponent } from './toaster.component'

@Injectable()
export class ToasterService {
  constructor(private snackbar: MatSnackBar) {}

  error(head: string, body?: string | unknown) {
    if (typeof body === 'object') {
      // TODO: parse error message; append to head
      body = ''
    }

    this.snackbar.openFromComponent(ToasterComponent, {
      data: { head, body },
      duration: 1000000,
      panelClass: `papi-toaster-error`,
    })
  }

  warning(head: string, body?: string) {
    this.snackbar.openFromComponent(ToasterComponent, {
      data: { head, body },
      duration: 10000,
      panelClass: `papi-toaster-warning`,
    })
  }

  success(head: string, body?: string) {
    this.snackbar.openFromComponent(ToasterComponent, {
      data: { head, body },
      duration: 5000,
      panelClass: `papi-toaster-success`,
    })
  }

  info(head: string, body?: string) {
    this.snackbar.openFromComponent(ToasterComponent, {
      data: { head, body },
      duration: 10000,
      panelClass: `papi-toaster-info`,
    })
  }

  progress(head: string, body?: string) {
    this.snackbar.openFromComponent(ToasterComponent, {
      data: { head, body, progress: true },
      panelClass: `papi-toaster-progress`,
    })
  }

  pop(data: { type: string; head?: string; html?: string }) {
    this.snackbar.openFromComponent(ToasterComponent, {
      data,
      duration: 10000,
      panelClass: `papi-toaster-${data.type}`,
    })
  }
}
